export default __webpack_public_path__ + "static/media/video-bg.bfc3ca87.webp";